// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".notification__toast[data-v-84236cdc]{width:280px;box-shadow:none;height:104px;margin-top:1px;text-align:left;border:1px solid var(--border-color)}", ""]);
// Exports
module.exports = exports;
